import experimentHooks from "../../experimentHooks";
import {checkFrequencyCap, storeFrequencyImpression} from "../../tools/shared";

(() => {
    const expName = 'clickAds';
    const clickunderFrequencyParams = {
        "cap": 6,
        "intervalAmount": 1,
        "intervalType": "day"
    }
    const clickunderStorageKey = 'clickunder-freq'
    function openClickunder (link) {
        if (checkFrequencyCap(clickunderFrequencyParams, clickunderStorageKey)) {
            storeFrequencyImpression(clickunderFrequencyParams, clickunderStorageKey);
            window.open(link)
        }
    }
    let modalEventCount = 0
    window[expName] = {
        isAvailable() {
            return true;
        },

        init() {
            const url = window[expName].url
            experimentHooks.clickAds.on((event) => {
                if (event === 'open') {
                    openClickunder(url)
                } else if (event === 'modalEvent') {
                    modalEventCount += 1
                    if (modalEventCount % 5 === 0) {
                        openClickunder(url)
                    }
                }
            })
          return true
        },
    };
})()
